import script from "./PasswordSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordSetting.vue?vue&type=script&setup=true&lang=js"

import "./PasswordSetting.vue?vue&type=style&index=0&id=2f278348&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f278348"]])

export default __exports__